"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseAbilityHandler = exports.CollapseActorAbilityFactory = exports.CollapseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Darkness_1 = require("../../core/effects/core/Darkness");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Registries_1 = require("../../core/state/Registries");
class CollapseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Collapse;
        this.__typeName = "Collapse";
    }
}
exports.CollapseAbilityArgs = CollapseAbilityArgs;
let CollapseActorAbilityFactory = class CollapseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Collapse", "OneEnemies", 2);
    }
};
CollapseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Collapse")
], CollapseActorAbilityFactory);
exports.CollapseActorAbilityFactory = CollapseActorAbilityFactory;
let CollapseAbilityHandler = class CollapseAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 150)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new Darkness_1.DarknessEffectArgs(),
                        new Vulnerability_1.VulnerabilityEffectArgs(4)
                    ], true),
                });
            }
        });
    }
};
CollapseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Collapse)
], CollapseAbilityHandler);
exports.CollapseAbilityHandler = CollapseAbilityHandler;
